import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/configs',
)({
  component: lazyRouteComponent(() => import('./configs.component'), 'ClusterConfigsComponent'),
});
